<div class="flex flex-col gap-2" [formGroup]="pharmacyForm()">
  <label
    for="pharmacistNationalId"
    class="text-[14px] font-[500] hover:cursor-pointer"
    i18n="@@adminCreatePharmacyNationalId">
    Pharmacist National ID
    <span class="text-danger-text">*</span>
  </label>
  <input
    id="pharmacistNationalId"
    type="text"
    formControlName="pharmacistNationalId"
    placeholder="Enter Pharmacist National Id"
    i18n-placeholder="@@adminCreatePharmacyNationalIdPlaceholder"
    class="border-border bg-surface-subtle placeholder-text-gray hover-border-input-border focus-border-gray-strong rounded-[6px] border-[1px] px-3 py-2 text-[14px] focus:bg-white focus:outline-none"
    [class.border-red-500]="
      pharmacyForm().get('pharmacistNationalId')?.invalid && pharmacyForm().get('pharmacistNationalId')?.touched
    " />
  @if (pharmacyForm().get("pharmacistNationalId")?.invalid && pharmacyForm().get("pharmacistNationalId")?.touched) {
    <span class="text-danger-text text-[12px]">
      @if (pharmacyForm().get("pharmacistNationalId")?.errors?.["required"]) {
        <span i18n="@@adminCreatePharmacyErrorNationalIdRequired">National ID is required</span>
      }
      @if (
        (pharmacyForm().get("pharmacistNationalId")?.errors?.["minlength"] ||
          pharmacyForm().get("pharmacistNationalId")?.errors?.["maxlength"]) &&
        !pharmacyForm().get("pharmacistNationalId")?.errors?.["pattern"]
      ) {
        <span i18n="@@adminCreatePharmacyErrorNationalIdLength">National ID must be exactly 14 digits</span>
      }

      @if (pharmacyForm().get("pharmacistNationalId")?.errors?.["pattern"]) {
        <span i18n="@@adminCreatePharmacyErrorNationalIdPattern">National ID must contain only numbers</span>
      }
    </span>
  }
</div>
